<template>
  <div>
    <b-modal :active.sync="show" has-modal-card>
      <form action="">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head is-bg-primary">
            <p class="modal-card-title has-text-white">KHS <span v-if="!isEmpty(account)"> - {{ account.name }}</span></p>
          </header>
          <section class="modal-card-body">
            <b-field label="Periode">
              <b-select placeholder="Pilih periode" v-model="periode_khs">
                <option
                  v-for="(periode, key) in periode_khs_collection"
                  :value="periode.id"
                  :key="key">
                  {{ periode.name }}
                </option>
              </b-select>
            </b-field>

            <b-table v-if="!isEmpty(data_khs)" :data="data_khs.mataKuliah">
              <template slot-scope="props">
                <b-table-column field="namaMataKuliah" label="Mata Kuliah">
                  <p class="title" style="font-size: 15px;">{{ props.row.namaMataKuliah }}</p>
                  <p class="subtitle" style="font-size: 14px;">{{ props.row.kodeMataKuliah }}</p>
                </b-table-column>

                <b-table-column field="sks" label="SKS">
                  {{ props.row.sks }} SKS
                </b-table-column>

                <b-table-column field="nilaiHuruf" label="Nilai Huruf" centered>
                  {{ props.row.nilaiHuruf || '-' }}
                </b-table-column>

                <b-table-column field="nilaiAkhir" label="Nilai Angka" centered>
                  {{ props.row.nilaiAkhir || '-' }}
                </b-table-column>
              </template>
            </b-table>
          </section>
          <footer class="modal-card-foot">
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { ACCOUNT } from '~/consts';

export default {
  props: {
    account: {
      type: Object,
      default: null
    },
    onHide: {
      type: Function,
      default: () => {}
    }
  },

  computed: {
    nim() {
      if (!this.isEmpty(this.account)) {
        return this.account.userUniversityId
      }

      return null;
    },
    periode_khs_collection() {
      return collect(this.khs).map((i) => {
        return {
          id: i.idperiode,
          name: i.periode
        }
      }).toArray()
    },
    data_khs() {
      if (!this.isEmpty(this.khs)) {
        return collect(this.khs).where('idperiode', this.periode_khs).first();
      }

      return [];
    },
    show: {
      get() {
        return !this.isEmpty(this.nim) ? true : false
      },
      set() {
        this.onHide();
      }
    }
  },

  watch: {
    account(val) {
      if (!this.isEmpty(val)) {
        this.getData()
      } else {
        this.khs = [];
        this.periode_khs = null
      }
    },
  },

  data() {
    return {
      periode_khs: null,
      khs: [],
    }
  },

  methods: {
    getData() {
      const vm = this;

      this.$axios.post(ACCOUNT.GET_KHS(this.account.universityId), {
        isDefault: 0,
        user_university_id: this.nim
      }).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          vm.khs = data.data;
        } else {
          this.$buefy.toast.open(data.applicationSystem.message);
        }
      }).catch(({ response }) => {
      })
    }
  }
}
</script>

<style>

</style>
